
import { MapTo } from '@adobe/aem-react-editable-components';
import MarketingClaims, { MarketingClaimsEditConfig } from './MarketingClaims';

export default MapTo('cob-corp-acquisition/components/creditonebank/marketing-claims')(MarketingClaims, MarketingClaimsEditConfig);
        